// Helpers for cleaning up the blog post list before it is rendered.
//
// Ported from NevTan Sign's src/utils/blogPosts.js.
import type { BlogPost } from './blogApi'

/** A post is considered to have an image if it has either a hero or a thumbnail. */
export function postHasImage(p?: BlogPost | null): boolean {
  return !!(p?.heroImageUrl || p?.thumbnailUrl)
}

function normalizeTitle(p?: BlogPost | null): string {
  return (p?.title || '').trim().toLowerCase().replace(/\s+/g, ' ')
}

/**
 * The API sometimes returns the same article more than once (same title, e.g. "…-3" slug
 * variants) — one copy with an image, one without. Collapse those to a single entry, always
 * keeping the copy that has an image.
 */
export function dedupePosts(pages?: BlogPost[] | null): BlogPost[] {
  if (!Array.isArray(pages)) return []
  const byTitle = new Map<string, BlogPost>()
  for (const p of pages) {
    if (!p) continue
    const key = normalizeTitle(p)
    const existing = byTitle.get(key)
    if (!existing) {
      byTitle.set(key, p)
      continue
    }
    // Prefer the copy with an image; otherwise keep the first one seen.
    if (!postHasImage(existing) && postHasImage(p)) byTitle.set(key, p)
  }
  return Array.from(byTitle.values())
}
